<template>
  <modal
    :show="isVisible"
    :title="t('Emitir taxa de implantação')"
    elem-id="modal_setup_fee_emit"
    size="compactDesktop"
    :close-label="t('Cancelar')"
    :save-label="t('Emitir cobrança')"
    :save-fn="handleSave"
    save-test-id="setup-fee-emit-submit"
    @close="handleClose"
    @dismiss="handleClose"
  >
    <template v-if="isVisible">
      <setup-fee-emit-form
        ref="formRef"
        :initial-franquia-id="initialData.franquiaId"
        :initial-installments="initialData.installments"
        @saved="handleSaved"
      />
    </template>
  </modal>
</template>

<script setup lang="ts">
import { ref, reactive, onMounted, onBeforeUnmount } from 'vue'
import { useI18n } from 'vue-i18n'
import { eventBus } from '../../../eventBus'
import { log } from '../../../utils/DebugLogger'
import Modal from '../../../ui/Modal.vue'
import SetupFeeEmitForm from './SetupFeeEmitForm.vue'
import type { SetupFee_EmitResponseDados } from '../../../contracts/SetupFee_EmitResponse'

const { t } = useI18n()

const isVisible = ref(false)
const formRef = ref<InstanceType<typeof SetupFeeEmitForm> | null>(null)

const initialData = reactive({
  franquiaId: null as number | null,
  installments: null as number | null,
})

function handleOpen(payload?: {
  franquiaId?: number
  installments?: number
}): void {
  log('SetupFeeEmitModal', 'handleOpen', 'Opening emit modal', payload)
  initialData.franquiaId = payload?.franquiaId ?? null
  initialData.installments = payload?.installments ?? null
  isVisible.value = true
}

function handleClose(): void {
  log('SetupFeeEmitModal', 'handleClose', 'Closing emit modal')
  isVisible.value = false
}

async function handleSave(): Promise<void> {
  log('SetupFeeEmitModal', 'handleSave', 'Submitting setup fee emit')
  await formRef.value?.handleSubmit()
}

function handleSaved(dados: SetupFee_EmitResponseDados): void {
  log('SetupFeeEmitModal', 'handleSaved', 'Setup fee emitted successfully', dados)
  eventBus.emit('setup-fee.emitted', dados)
  eventBus.emit('subscriptions.refresh')
  eventBus.emit('globalMessage.success', t('Taxa de implantação emitida com sucesso'))
  handleClose()
}

onMounted(() => {
  eventBus.on('modal.setup-fee-emit.open', handleOpen)
})

onBeforeUnmount(() => {
  eventBus.off('modal.setup-fee-emit.open', handleOpen)
})
</script>
